export const PRISM_LOADED_EVENT = 'onPrismLoaded' as const
export const PRISM_STATE_CHANGE_EVENT = 'onPrismStateChange' as const
export const PRISM_SCAN_COMPLETE_EVENT = 'onPrismScanComplete' as const
